import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-license": () => import("/app/modules/license/middleware/check-license.ts"),
  guest: () => import("/app/middleware/guest.ts"),
  offline: () => import("/app/middleware/offline.ts")
}